import contextMenu from '../components/contextmenu/index';
import { connect } from 'react-redux';
import { setPoint } from '../routing/actions';
import { map } from '../map/map';
import { showMenu } from './actions';
import { revGeoAddress } from '../reverseGeocoding/actions';

import {transform} from 'ol/proj';

const mapStateToPropsRes = (state) => {

  if(state.routing.waypoints.length === 0) {
    var items = [ {id: 'route_from', name: translations.ROUTING_FROM}];
  } else {
    var items = [ {id: 'route_to', name: translations.ROUTING_TO}];
  }
  
  const wgsCoords = transform(state.contextmenu.coords, 'EPSG:3857', 'EPSG:4326');
  
  const coordText = parseFloat(wgsCoords[1]).toFixed(6) + ", "+parseFloat(wgsCoords[0]).toFixed(6);
  
  return {
  	isRoutingAllowed: state.routing.isMaxPoints,
  	position: state.contextmenu.pixel,
  	items: [],
    title: state.contextmenu.address,
    coords: coordText
  };
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickHandler: (ev, data) => {

      return;
    }
  };
};

const mapPopupContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(contextMenu);

export default mapPopupContainer;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/contextmenu/container.js